export default __webpack_public_path__ + "static/media/flag-romania.d386536b.svg";